<template>
    <ValidationObserver
        ref="testCalculation"
        v-slot="{ passes}"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_PUBLISHING_WORKS_ACTION_OPTION_TEST_CALCULATION_C3"
            :close="closeDialog"
            maxDialogWidth="1300"
            maxCardHeight="800"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row class="pl-3 pt-3 headline">
                        {{ getWorkName() }}
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <BaseEditPageTextField 
                                :context="context"
                                field="Amount"
                                :label="$t('lang_GENERIC_CAPTION_AMOUNT')" 
                                :withMargin="false"
                                rules="required"
                                :alvqa="alvqa + '-textfield-amount'"
                                :suffix="$store.getters.getSelectedCurrency"
                            />
                        </v-col>
                        <v-col cols="4">
                            <BaseEditPageTextField 
                                :context="context"
                                field="CollPercent"
                                :label="$t('lang_GENERIC_CAPTION_COLL_PERCENT')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-coll-percent'"
                            />
                        </v-col>
                        <v-col cols="4">
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Country"
                                :items="countryItems" 
                                :label="$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_ORIGINATING_COUNTRY')"
                                :selection="true"
                                :withMargin="false"
                                :resetValNull="true"
                                :alvqa="alvqa + '-dropdown-country'"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <BaseEditPageDropdown
                                field="SourceId"
                                :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SOURCE')"
                                :items="mappingsSourceOptions"
                                :context="context"
                                :withMargin="false"
                                :alvqa="alvqa + '-dropdown-source-id'"
                                :resetValNull="true"
                            />
                        </v-col>
                        <v-col cols="6">
                            <BaseEditPageAutocomplete
                                :context="context"
                                field="RecipientId"
                                :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_RECIPIENT')"
                                :withFreeText="false"
                                :withMargin="false"
                                :alvqa="alvqa + '-autocomplete-recipient'"
                            >
                                <template v-slot:selection="{ item }">
                                <div
                                    class="ellipsis"
                                    :alvqa="
                                    alvqa + '-autocomplete-recipient-selection'
                                    "
                                >
                                    {{ item.gemaName }}
                                    <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                    </span>
                                </div>
                                </template>
                                <template v-slot:items="{ items }">
                                <v-list-item-content
                                    :alvqa="
                                    alvqa +
                                    '-autocomplete-recipient-dropdown-' +
                                    items.alvId
                                    "
                                >
                                    <v-list-item-title
                                    :alvqa="
                                        alvqa +
                                        '-autocomplete-recipient-dropdown-' +
                                        items.alvId +
                                        '-title'
                                    "
                                    >
                                    {{ items.gemaName }}
                                    {{
                                        $alvPlugin.printName(items)
                                        ? "(" + items.firstName + " " + items.lastName + ")"
                                        : ""
                                    }}
                                    <!--  
                                                typeOfAz:
                                                    allowed values: P, D or G
                                                    P => Person => P in circle
                                                    D => Distributor => D in circle (in german V for 'Vertrieb')
                                                    G => Group => G in circle                                                
                                                -->
                                    <v-avatar color="grey" size="20" class="caption">{{
                                        items.typeOfAz
                                    }}</v-avatar>
                                    <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                    :alvqa="
                                        alvqa +
                                        '-autocomplete-recipient-dropdown-' +
                                        items.alvId +
                                        '-subtitle'
                                    "
                                    >
                                    {{ $t("lang_IPI") }}:
                                    {{
                                        items.ipi !== null &&
                                        items.ipi !== "" &&
                                        items.ipi !== undefined
                                        ? items.ipi
                                        : $t("lang_GENERIC_CAPTION_NOMEN_NOMINANDUM")
                                    }}
                                    | {{ items.alvId }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                </template>
                            </BaseEditPageAutocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <BaseEditPageDropdown 
                                :context="context"
                                field="RightsTypes"
                                :items="rightsDropdownItems" 
                                :label="$t('lang_GENERIC_CAPTION_RIGHTS_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                :clearable="false"
                                rules="required"
                                :alvqa="alvqa + '-dropdown-rights-types'"
                            />
                        </v-col>
                        <v-col cols="4">
                            <BaseEditPageTextField 
                                :context="context"
                                field="Category"
                                :label="$t('lang_GENERIC_CAPTION_CATEGORY')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-category'"
                            />
                        </v-col>
                        <v-col cols="4">
                            <BaseEditPageTextField 
                                :context="context"
                                field="SubCategory"
                                :label="$t('lang_GENERIC_CAPTION_SUBCATEGORY')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-subcategory'"
                            />
                        </v-col>
                    </v-row>
                    <v-divider class="mb-2" />
                    <v-row v-if="errorMessage !== null">
                        <v-col>
                            <v-chip  
                                small 
                                label
                                color="errorLineChip"
                                text-color="errorLineText"
                                class="mb-6 mt-5"
                                :alvqa="alvqa + 'result-chip-error'"
                            >{{ $t('lang_GENERAL_CAPTION_ERROR') }}</v-chip>
                            {{  $t(errorMessage) }}
                        </v-col>
                    </v-row>

                    <!-- RESULT -->
                    <v-row v-for="(entry, rightsType) in result" :key="rightsType">
                        <v-col>
                            <v-chip 
                                label 
                                class="ml-3 mb-2 mt-2"
                                color="resultHeadlineBackground" 
                                text-color="resultHeadlineText"
                                :alvqa="alvqa + '-result-list-chip-type-of-right-' + rightsType.toLowerCase().replace(/\s+/g, '-')"
                            >{{ $t(getRightsType(rightsType)).toUpperCase() }} </v-chip> 
                            <!-- TODO_PT: how to deal with translation of rightstype, at least AR <-> PR -->
                            <v-row>
                                <v-col>
                                    <v-data-table
                                    v-if="entry[0].error === -1"
                                    :headers="resultHeaders"
                                    :items="entry"
                                    hide-default-footer
                                    disable-sort
                                    dense
                                    :items-per-page="itemsPerPage"
                                    >
                                    <template v-slot:item="{ item, index }">
                                        <tr>
                                            
                                            <td class="ellipsis" :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-statement-for'">
                                                <BaseTooltip :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-statement-for'">
                                                    <!-- mouseover text -->
                                                    <template v-slot:text>
                                                        <span>{{ item.statementForName }} ({{  item.statementForAlvId }})</span>
                                                    </template>
                                                    <!-- text on screen -->
                                                    <template v-slot:content>
                                                        <span :style="{ fontWeight: 'bold' }">{{ item.statementForName }}</span>
                                                    </template>
                                                </BaseTooltip>
                                            </td>

                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-amount'"
                                                 > {{ $alvPlugin.formatMoney(item.amount) }}</td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-base-percent'"
                                                > {{ $alvPlugin.getNumberLocalization(item.basePercent, 'number') }} </td>
                                                <td 
                                                    class="text-right"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-share-percent'"
                                                > {{ $alvPlugin.getNumberLocalization(item.sharePercent, 'number') }} </td>
                                                <td 
                                                    class="text-right" :style="{ fontWeight: 'bold' }" 
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-share-amount'"
                                                > {{ $alvPlugin.formatMoney(item.shareAmount) }} </td>
                                                <!-- <td 
                                                    class="ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-calculation-rule'"
                                                ><BaseTooltip :simpleText="item.conditionRow" /></td> -->
                                                <td 
                                                    class="no_ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-publishing-contract'"
                                                > {{ item.publishingContractAlvId }}</td>
                                                <td 
                                                    class="no_ellipsis"
                                                    :alvqa="alvqa + '-result-list-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-row-' + (index+1) + '-text-contract-type'"
                                                > {{ $alvPlugin.isLangConst(item.publishingContractType) ? $t(item.publishingContractType) : item.publishingContractType }}</td>
                                            </tr>

                                            <!-- CONDITIONS ROW -->
                                            <tr v-if="item.conditionRowInfo !== undefined && item.conditionRowInfo !== null && item.conditionRowInfo.length !== 0">
                                                <td colspan="8" :alvqa="alvqa + 'result-list-row-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-condition-row'">
                                                        <v-chip  
                                                            small 
                                                            :style="{ width: '100px' }"
                                                            label
                                                            color="contractLineChip"
                                                            class="mr-2"
                                                            :alvqa="alvqa + 'result-list-row-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-chip-condition'"
                                                        >{{ $t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_ROW') }}</v-chip>

                                                        {{ $t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SOURCE') }}: {{ item.conditionRowInfo.source !== null ? item.conditionRowInfo.source : '--' }} | 
                                                        {{ $t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_RECIPIENT') }}: {{ item.conditionRowInfo.recipient !== null ? item.conditionRowInfo.recipient : '--' }} | 
                                                        {{ $t('lang_GENERIC_CAPTION_COLL_PERCENT_PR') }}: {{ item.conditionRowInfo.collPercentPr !== null ? $n(item.conditionRowInfo.collPercentPr, 'number') : '--' }} | 
                                                        {{ $t('lang_GENERIC_CAPTION_COLL_PERCENT_MR') }}: {{ item.conditionRowInfo.collPercentMr !== null ? $n(item.conditionRowInfo.collPercentMr, 'number') : '--' }}
                                                </td>
                                            </tr>

                                            <!-- SPLITS ROW -->
                                            <tr v-if="item.splitRowInfo !== undefined && item.splitRowInfo !== null && item.splitRowInfo.length !== 0">
                                                <td colspan="8" :alvqa="alvqa + 'result-list-row-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-split-row'">
                                                        <v-chip  
                                                            small 
                                                            :style="{ width: '100px' }"
                                                            label
                                                            color="contractLineChip"
                                                            class="mr-2"
                                                            :alvqa="alvqa + 'result-list-row-' + rightsType.toLowerCase().replace(/\s+/g, '-') + '-chip-split'"
                                                        >{{ $t('lang_CONTRACTS_PUBLISHING_CAPTION_SPLITS_ROW') }}</v-chip>
 
                                                        {{ $t('lang_GENERIC_CAPTION_RIGHTS_TYPE') }}: {{ item.splitRowInfo.rightsType !== null ? $t(getRightsType(item.splitRowInfo.rightsType)).toUpperCase() : '--' }} | 
                                                        {{ $t('lang_GENERIC_CAPTION_CATEGORY') }}: {{ item.splitRowInfo.category !== null ? item.splitRowInfo.category : '--' }} | 
                                                        {{ $t('lang_GENERIC_CAPTION_SUBCATEGORY') }}: {{ item.splitRowInfo.subCategory !== null ? item.splitRowInfo.subCategory : '--' }} | 
                                                        {{ $t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_REGION') }}: {{ item.splitRowInfo.region !== null ? item.splitRowInfo.region : '--' }} | 
                                                        {{ $t('lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_APPLY_TO') }}: 
                                                        <div style="display: inline-block"><BaseTooltip>
                                                            <template v-slot:content>
                                                                <div
                                                                    :alvqa="alvqa + '-splits-list-row-apply-to'"
                                                                >
                                                                    {{ item.splitRowInfo.applyTo !== null ? getApplyTo(item.splitRowInfo.applyTo, item.splitRowInfo.recipientId) : '--' }}
                                                                </div>
                                                            </template>
                                                            <!-- this is the mouseover text -->
                                                            <template v-slot:text v-if="item.splitRowInfo.applyTo == 'byAlvId' && item.splitRowInfo.recipientId !== null">
                                                                {{ item.splitRowInfo.recipientId.name }} ({{ item.splitRowInfo.recipientId.alvId }})
                                                            </template>
                                                            <template v-slot:text v-else>
                                                                {{ item.splitRowInfo.applyTo !== null ? getApplyTo(item.splitRowInfo.applyTo, null) : '--' }}
                                                            </template>
                                                        </BaseTooltip></div> | 
                                                        {{ $t('lang_GENERIC_CAPTION_SPLIT') }}: {{ item.splitRowInfo.splitPercent !== null ? $n(item.splitRowInfo.splitPercent, 'number') + '%' : '--' }} | 
                                                        {{ $t('lang_GENERIC_CAPTION_BASE') }}: {{ item.splitRowInfo.base !== null ? $n(item.splitRowInfo.base, 'number') + '%' : '--' }} | 
                                                        {{ $t('lang_PUBLISHING_CAPTION_WEIGHTING') }}: {{ item.splitRowInfo.weighting !== null ? getWeighting(item.splitRowInfo) : '--' }}
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <!-- <div v-else-if="entry[0].error === 1"> -->
                                    <v-row v-else-if="entry[0].error === 1" class="mt-1">
                                        <v-col cols="1">
                                            <v-chip  
                                                small 
                                                label
                                                color="errorLineChip"
                                                text-color="errorLineText"
                                                class="ml-4"
                                                :alvqa="alvqa + '-result-chip-error'"
                                            >{{ $t('lang_GENERAL_CAPTION_ERROR') }}</v-chip>
                                        </v-col>
                                        <v-col class="pl-0" :alvqa="alvqa + '-result-error-text'">
                                            {{ $t(entry[0].splitRowInfo.error) }}
                                        </v-col>
                                    </v-row>
                                </v-col> 
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_CAPTION_CALCULATE"
                                @click="passes(calculate)"
                                :alvqa="alvqa+'-button-calculate'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>    
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageAutocomplete from "@/components/_editForm/BaseEditPageAutocomplete";
import BaseTooltip from '@/components/_base/BaseTooltip'

import {    DropdownContractsPublishingSplitsApplyTo, 
            DropdownWeighting,
            DropdownRightsType,
            DropdownWeightingSource,
            DropdownSharesToConsider } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TestCalculationC3Dialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageAutocomplete,
        BaseTooltip,
    },
    data() {
        return {
            context: "TestCalculationC3",
            alvqa: 'publishing-works-list-dialog-test-calculation-C3'
        }
    },
    computed: {
        itemsPerPage() { return this.$store.getters.getItemsPerPage },

        rightsDropdownItems() {
            return DropdownRightsType;
        },

        mappingsSourceOptions() {
            let retList = this.$store.getters.getTestCalculationC3SourceIdOptions.map((el) => {
                el.text = `${el.text} (${el.value})`;
                return el;
            });

            return retList;
        },

        countryItems() { return this.$alvPlugin.getListOfTranslatedCountries() },

        result: {
            get() { return this.$store.getters.getTestCalculationC3Result},
            set(result) { this.$store.commit('setTestCalculationC3Result', result) }
        } ,
        errorMessage: { 
            get() { return this.$store.getters.getTestCalculationC3ResultErrorMessage },
            set(msg) { this.$store.commit('setTestCalculationC3ResultErrorMessage', msg) }
        },

        showDialog: {
            get() { return this.$store.getters.getTestCalculationC3Dialog },
            set(value) { this.$store.commit('setTestCalculationC3Dialog', value) }
        },
        
        resultHeaders() {
            return [
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_STATEMENT_FOR'), 
					value: 'statementForName', 
					align: 'left',
                    width: "140px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_AMOUNT') + ' ' + this.$store.getters.getSelectedCurrency,
					value: 'amount', 
                    align: 'right', 
                    width: "140px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_BASE') + ' %',
					value: 'basePercent', 
                    align: 'right', 
                    width: "90px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_SHARE') + ' %',
					value: 'sharePercent', 
                    align: 'right', 
                    width: "90px",
                    sortable: false,
					class: 'text-no-wrap'
                }, 
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_SHARE') + ' ' + this.$store.getters.getSelectedCurrency,
					value: 'shareAmount', 
                    align: 'right', 
                    width: "140px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				// {
				// 	text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONDITIONS_ROW'), 
				// 	value: 'conditionRow', 
				// 	align: 'left',
                //     sortable: false,
				// 	class: 'ellipsis'
                // },
				{
					text: this.$t('lang_PUBLISHING_WORKS_DIALOG_CAPTION_PUBLISHING_CONTRACT'), 
					value: 'publishingContractAlvId', 
                    align: 'left',
                    width: "160px",
                    sortable: false,
					class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE'), 
					value: 'publishingContractType', 
                    align: 'left',
                    width: "125px",
                    sortable: false,
					class: 'text-no-wrap'
                }
            ]
        },        
    },
    methods: {

        closeDialog() {
            this.showDialog = false
            this.$store.commit('setSelectedWorksAction', [])
            this.$store.commit('setSelectedWorks', [])
            this.result = []
            this.errorMessage = null
            this.$store.commit('setIsAllSelectedWorks', false)
        },
        calculate() {
            this.result = []
            this.errorMessage = null
            this.$store.dispatch('calculateC3TestCalculation')
        },
        getContractRightConst(right) {
            let contractRights = this.$store.getters.getContractsRights
            let text = ''
            contractRights.forEach(entry => {
                if(entry.value === right) text = entry.text
            });

            return text
        },    
        getWorkName() {
            let selectedWorkAlvId = this.$store.getters.getSelectedWorks
            let works = this.$store.getters.getWorks
            let title = ''

            let match = works.find(work => work.alvId === selectedWorkAlvId[0])
            if(match !== undefined) {
                title += match.title + ' (' + match.alvId
                if(match.gemaNumber !== null && match.gemaNumber !== '') title += ' | ' + match.gemaNumber
                title += ')'
            }
            return title
        },
        getApplyTo(applyToValue, recipientId) {
            let applyToValues = DropdownContractsPublishingSplitsApplyTo;
            if(applyToValue === null) return '';

            let applyToMatch =  applyToValues.find(applyTo => {
                return applyTo.value === applyToValue;
            })

            if(applyToMatch == undefined) return '';

            let recipientText = '';
            if(recipientId !== null) {
                recipientText = ` ${recipientId.name}`;
            }

            return `${this.$t(applyToMatch.text)}${recipientText}`;
        },
        getWeighting(splitRow) {
            let weightingValue = splitRow.weighting
            let weightingSource = splitRow.weightingSource
            let sharesToConsider = splitRow.sharesToConsider
            let weightingValues = DropdownWeighting
            if(weightingValue === null) return ''
            
            let weightingMatch =  weightingValues.find(weighting => {
                return weighting.value === weightingValue
            })
            if(weightingMatch == undefined) {
                return ''
            }

            let weightingLangConst = weightingMatch.text
            let weightingText = this.$t(weightingLangConst)

            // Find weigthing source in dropdown to get lang const if it is original shares
            // Otherwise stick with plain value that is stored in .weigtingSource property
            if (weightingSource) {
                let match = DropdownWeightingSource.find(source => {
                    return weightingSource === source.value
                })

                if (match) {
                    weightingSource = match.text
                }
            }

            if (sharesToConsider) {
                let match = DropdownSharesToConsider.find(share => {
                    return sharesToConsider === share.value
                })

                if (match) {
                    sharesToConsider = match.text
                }
            }

            weightingText += ` | ${this.$t(weightingSource)} | ${this.$t(sharesToConsider)}`

            return weightingText
        },
        getRightsType(rightsTypeValue) {
            let rightsTypeValues = DropdownRightsType
            if(rightsTypeValue === null) return ''
            else {
                let rightsTypeMatch =  rightsTypeValues.find(rightsType => {
                    return rightsType.value === rightsTypeValue
                })
                if(rightsTypeMatch !== undefined) return rightsTypeMatch.text
            }
        },
    },
    created() {
        this.$store.commit('setCountries')
        this.$store.dispatch("fetchTestCalculationC3AzOfSource");
    }
}
</script>